<div class="layout-topbar">
  <!-- Desktop: sidebar toggle + breadcrumb -->
  <ng-container *ngIf="!isMobile">
    <div class="topbar-left">
      <button
        #menubutton
        class="topbar-sidebar-toggle"
        aria-label="Alternar menú lateral"
        (click)="onSidebarToggle()"
      >
        <span class="material-symbols-outlined" aria-hidden="true">menu</span>
      </button>
    </div>
    <div class="topbar-center">
      <nav class="topbar-breadcrumb" *ngIf="breadcrumbs.length > 0">
        <ng-container
          *ngFor="let crumb of breadcrumbs; let last = last; trackBy: trackByBreadcrumbUrl"
        >
          <a *ngIf="!last" class="breadcrumb-link" [routerLink]="crumb.url">{{ crumb.label }}</a>
          <span *ngIf="!last" class="breadcrumb-separator">
            <i class="pi pi-chevron-right" aria-hidden="true"></i>
          </span>
          <span *ngIf="last" class="breadcrumb-current">{{ crumb.label }}</span>
        </ng-container>
      </nav>
    </div>
  </ng-container>

  <!-- Mobile: back + page title + menu -->
  <ng-container *ngIf="isMobile">
    <div class="topbar-left">
      <a
        class="topbar-mobile-back"
        *ngIf="breadcrumbs.length > 1"
        aria-label="Volver"
        (click)="goBack()"
      >
        <span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
      </a>
    </div>
    <div class="topbar-center topbar-center--mobile">
      <span class="topbar-page-title">{{
        breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1].label : 'Globot'
      }}</span>
    </div>
  </ng-container>

  <!-- Right: help + divider + avatar + name + dropdown (desktop) -->
  <div class="topbar-right" *ngIf="user">
    <!-- Desktop -->
    <ng-container *ngIf="!isMobile">
      <div class="topbar-help" aria-label="Ayuda" (click)="helpMenu.toggle($event)">
        <span class="material-symbols-outlined" aria-hidden="true">help_outline</span>
        <p-tieredMenu
          #helpMenu
          [model]="helpItems"
          [popup]="true"
          [style]="{ width: '260px' }"
          appendTo="body"
          [style.position]="'fixed'"
        ></p-tieredMenu>
      </div>
      <p-tieredMenu
        #menu
        [model]="items"
        [popup]="true"
        appendTo="body"
        [style.position]="'fixed'"
      ></p-tieredMenu>
    </ng-container>

    <!-- Mobile -->
    <ng-container *ngIf="isMobile">
      <a
        class="topbar-mobile-menu-btn"
        [attr.aria-label]="sidebarVisible ? 'Cerrar menú' : 'Abrir menú'"
        (click)="sidebarVisible = !sidebarVisible"
      >
        <span class="material-symbols-outlined" aria-hidden="true">{{
          sidebarVisible ? 'close' : 'menu'
        }}</span>
      </a>

      <!-- Mobile Menu Overlay -->
      <div *ngIf="sidebarVisible" class="mobile-menu-overlay">
        <button class="mobile-menu-close-btn" aria-label="Cerrar menú" (click)="closeMobileMenu()">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>

        <main class="mobile-menu-content">
          <section class="mobile-menu-section mobile-menu-workspace">
            <h3 class="mobile-menu-section-title">EQUIPO</h3>
            <globot-workspace-selector [collapsed]="false"></globot-workspace-selector>
          </section>

          <section
            *ngFor="let section of mobileMenuSections; trackBy: trackBySectionTitle"
            class="mobile-menu-section"
          >
            <h3 class="mobile-menu-section-title">{{ section.title }}</h3>
            <div class="mobile-menu-cards">
              <div
                *ngFor="let item of section.items; trackBy: trackByMenuItem"
                class="mobile-menu-card"
                (click)="onMobileMenuItemClick(item)"
              >
                <div class="mobile-menu-card-icon">
                  <span
                    *ngIf="item.materialIcon"
                    class="material-symbols-outlined"
                    aria-hidden="true"
                    >{{ item.materialIcon }}</span
                  >
                  <i *ngIf="!item.materialIcon" [class]="item.icon" aria-hidden="true"></i>
                </div>
                <div class="mobile-menu-card-text">
                  <span class="mobile-menu-card-title">{{ item.label }}</span>
                  <span class="mobile-menu-card-desc">{{ item.description }}</span>
                </div>
                <i class="pi pi-chevron-right mobile-menu-card-chevron" aria-hidden="true"></i>
              </div>
            </div>
          </section>

          <section class="mobile-menu-section">
            <h3 class="mobile-menu-section-title">AYUDA</h3>
            <div class="mobile-menu-cards">
              <div
                class="mobile-menu-card"
                (click)="onMobileMenuItemClick({ externalUrl: termsUrl })"
              >
                <div class="mobile-menu-card-icon">
                  <i class="pi pi-file-edit" aria-hidden="true"></i>
                </div>
                <div class="mobile-menu-card-text">
                  <span class="mobile-menu-card-title">Términos y condiciones</span>
                </div>
                <i class="pi pi-external-link mobile-menu-card-chevron" aria-hidden="true"></i>
              </div>
              <div
                class="mobile-menu-card"
                (click)="onMobileMenuItemClick({ externalUrl: privacyUrl })"
              >
                <div class="mobile-menu-card-icon">
                  <i class="pi pi-shield" aria-hidden="true"></i>
                </div>
                <div class="mobile-menu-card-text">
                  <span class="mobile-menu-card-title">Política de privacidad</span>
                </div>
                <i class="pi pi-external-link mobile-menu-card-chevron" aria-hidden="true"></i>
              </div>
              <div
                class="mobile-menu-card"
                (click)="onMobileMenuItemClick({ externalUrl: 'https://globot.ai/tutoriales/' })"
              >
                <div class="mobile-menu-card-icon">
                  <i class="pi pi-book" aria-hidden="true"></i>
                </div>
                <div class="mobile-menu-card-text">
                  <span class="mobile-menu-card-title">Tutoriales</span>
                </div>
                <i class="pi pi-external-link mobile-menu-card-chevron" aria-hidden="true"></i>
              </div>
              <div class="mobile-menu-card" (click)="openSupportForm(); closeMobileMenu()">
                <div class="mobile-menu-card-icon">
                  <i class="pi pi-comments" aria-hidden="true"></i>
                </div>
                <div class="mobile-menu-card-text">
                  <span class="mobile-menu-card-title">Contactar soporte</span>
                </div>
                <i class="pi pi-external-link mobile-menu-card-chevron" aria-hidden="true"></i>
              </div>
            </div>
          </section>
        </main>

        <footer class="mobile-menu-footer">
          <div
            *ngFor="let item of mobileMenuFooter; trackBy: trackByMenuItem"
            class="mobile-menu-footer-item"
            (click)="onMobileMenuItemClick(item)"
          >
            <span *ngIf="item.materialIcon" class="material-symbols-outlined" aria-hidden="true">{{
              item.materialIcon
            }}</span>
            <i *ngIf="!item.materialIcon" [class]="item.icon" aria-hidden="true"></i>
            <span>{{ item.label }}</span>
          </div>
          <div
            class="mobile-menu-footer-item mobile-menu-footer-item--logout"
            (click)="logout(); closeMobileMenu()"
          >
            <i class="pi pi-sign-out" aria-hidden="true"></i>
            <span>Cerrar sesión</span>
          </div>
        </footer>
      </div>
    </ng-container>
  </div>
</div>
